import React from "react";
import { Container, Box, Grid, Skeleton, Typography } from "@mui/material";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Hero from "./Hero";
import Info from "./Info";
import { useCourseDetails } from "../../hooks/useCourse";

function CourseDetails() {
    const { course, loading, error } = useCourseDetails();

    return (
        <Box>
            <Header />

            {/* Main Content Area */}
            <Box sx={{ minHeight: "85vh" }}>
                {loading ? (
                    <Container sx={{ py: 4 }}>
                        <Box sx={{ px: 2, py: 4 }}>
                            {/* Hero Section Skeleton */}
                            <Grid container spacing={4}>
                                {/* Left Column - Text Content */}
                                <Grid item xs={12} md={6}>
                                    <Skeleton variant="rectangular" height={36} width={120} sx={{ mb: 2 }} />
                                    <Skeleton variant="text" height={40} width="80%" />
                                    <Skeleton variant="text" height={30} width="90%" />
                                    <Skeleton variant="text" height={30} width="70%" sx={{ mb: 2 }} />
                                    <Skeleton variant="rectangular" height={48} width="50%" sx={{ borderRadius: 2 }} />
                                </Grid>

                                {/* Right Column - Thumbnail */}
                                <Grid item xs={12} md={6}>
                                    <Skeleton
                                        variant="rectangular"
                                        height={0}
                                        sx={{
                                            width: '100%',
                                            paddingTop: '56.25%', // 16:9 aspect ratio
                                            borderRadius: 2,
                                        }}
                                    />
                                </Grid>
                            </Grid>

                            {/* Info Section Skeleton */}
                            <Grid container spacing={4} sx={{ mt: 4 }}>
                                {/* Left Column - Content Blocks */}
                                <Grid item xs={12} md={8}>
                                    <Skeleton variant="text" height={36} width="60%" sx={{ mb: 2 }} />
                                    {[...Array(3)].map((_, idx) => (
                                        <Skeleton
                                            key={idx}
                                            variant="rectangular"
                                            height={80}
                                            width="100%"
                                            sx={{ borderRadius: 2, mb: 2 }}
                                        />
                                    ))}
                                </Grid>

                                {/* Right Column - MetaCard */}
                                <Grid item xs={12} md={4}>
                                    <Skeleton variant="rectangular" height={220} sx={{ borderRadius: 2 }} />
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                ) : course ? (
                    <>
                        <Hero course={course} />
                        <Info course={course} />
                    </>
                ) : (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '60vh',
                            textAlign: 'center',
                            px: 2,
                        }}
                    >
                        <Typography variant="h5" sx={{ mb: 1, color: 'text.primary', fontWeight: 600 }}>
                            No course found
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 400 }}>
                            We couldn't find a course matching your request. Please check the URL or try browsing available courses.
                        </Typography>
                    </Box>
                )}
            </Box>

            <Footer />
        </Box>
    );
}

export default CourseDetails;
